import { List } from "immutable";
import * as actions from "../actions/AdminNavListActions";
import { AdminNavListState, initialState } from "../store/AdminNavListState";
import buildReducer from "../utils/ReducerBuilder";

export const AdminNavListReducer = buildReducer<AdminNavListState>(initialState)
    .handle(actions.onAllReceived, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            loading: false,
            navItems: List(action.payload.navItems),
            types: List(action.payload.types),
        };
    })
    .handle(actions.updateNavItems, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            navItems: action.payload,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/AdminNavListReducer.ts